/* eslint-disable */
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { getEventsGrours } from '@/store/course/actions';

import { selectCourse } from '@/store/course/selectors';

import { Button, Input } from 'antd';
import { InfoCircleTwoTone } from '@ant-design/icons';

import { isConference, isEvent, isEventOrConference } from '@shared/utils/topic-utils';

import classNames from 'classnames';
import dayjs from 'dayjs';
import _get from 'lodash/get';
import PropTypes from 'prop-types';

import css from './CalendarModal.module.scss';

const { TextArea } = Input;

const ConfirmModal = props => {
  const { okText, comment, eventTypeId, onCancel, isLoadingPlan, dates, topicInfo, isMyProfile } = props;
  const dispatch = useDispatch();

  const topicStartDateFormat = isMyProfile
    ? dayjs(props.topicInfo.startDate).format('YYYY-MM-DD')
    : props.topicInfo.startDate;

  const dateEventFormat = isMyProfile
    ? dayjs(props.dateEvent, 'D MMMM YYYY').format('YYYY-MM-DD')
    : dayjs(props.dateEvent).format('YYYY-MM-DD');

  const { t } = useTranslation('confirmModal');
  const [selectedWebinarDate, setSelectedWebinarDate] = useState('');
  const [selectedMonths, setSelectedMonths] = useState(
    !props.disabledSelect ? [topicStartDateFormat] : [dateEventFormat]
  );

  const [commentVal, setCommentVal] = useState('');
  const text = isConference(eventTypeId) ? t('conf1') : t('conf2');

  const { eventsGroups, isLoading } = useSelector(selectCourse);

  useEffect(() => {
    dispatch(getEventsGrours({ topicId: topicInfo.id }));
  }, []);

  useEffect(() => {
    topicInfo &&
      Array.isArray(topicInfo.webinarCreateEventResponse) &&
      topicInfo.webinarCreateEventResponse.length > 0 &&
      topicInfo.webinarCreateEventResponse.every(item => {
        if (dayjs(item.startsAt).format('YYYY-MM-DD') === selectedMonths[0]) {
          setSelectedWebinarDate(item.startsAt);

          return false;
        } else {
          setSelectedWebinarDate('');
          return true;
        }
      });
  }, [selectedMonths]);

  const findIdByDate = (data, targetDate) => {
    const year = dayjs(targetDate, 'YYYY-MM-DD').year();

    if (!isEvent(topicInfo?.type?.id)) {
      return data[year].find(item => item.periods.some(period => period.dates.includes(targetDate)))?.id;
    }

    return undefined;
  };

  const handleOkClick = () => {
    const { onOk, planningTopicId, topicInfo, rest } = props;
    const months = selectedMonths.length > 0 ? selectedMonths : [topicInfo.startDate];
    const selectedEventId = findIdByDate(eventsGroups, selectedMonths?.[0]);

    onOk && onOk(planningTopicId, months, commentVal, false, selectedWebinarDate, rest, selectedEventId);
  };

  const onChangeComment = event => setCommentVal(_get(event, 'target.value', ''));

  const currentDates = Array.isArray(dates) && dates.length > 1 && (
    <>
      {dates
        .map(item => ({ ...item, date: dayjs(item.date) }))
        .sort((a, b) => a.date.isBefore(b.date))
        .map((date, index) => {
          if (date) {
            return (
              <div
                className={classNames(
                  selectedMonths.toString() === date.date.format('YYYY-MM-DD') && css['Calendar-modal-date_active'],
                  css['Calendar-modal-date']
                )}
                onClick={() => setSelectedMonths([date.date.format('YYYY-MM-DD')])}
                key={index}
              >
                <span>{dayjs(date.date, 'YYYY-MM-DD').format('LL')}</span>
                {isEventOrConference(topicInfo?.type?.id) && (
                  <span>
                    {`${dayjs(date?.startTime, 'HH:mm:ss').format('LT')} - ${dayjs(date?.endTime, 'HH:mm:ss').format(
                      'LT'
                    )}`}
                  </span>
                )}
              </div>
            );
          }
        })}
    </>
  );

  return (
    <div className={classNames(css['App-card-item'], css['Calendar-modal'])}>
      <div className={classNames(css['Calendar-modal-header'], css['Calendar-modal-header--ext'])}>
        <div className={css['Calendar-modal-header-title']}>
          <InfoCircleTwoTone twoToneColor='#FAAD14' />
          <div className={css['Calendar-modal-header-subTitle']}>
            <span className={css['Calendar-modal-header-subTitle-text']}>{t('title')}</span>
            {`${text} ${dayjs(selectedMonths.toString()).format('D MMMM YYYY')}?`}
          </div>
        </div>
      </div>
      {comment && !isConference(eventTypeId) && <div className={css['Calendar-modal-comment']}>{comment}</div>}
      {isConference(eventTypeId) && (
        <div className={css['Calendar-modal__row__field-marginTop']}>
          <TextArea
            className={css.Comment}
            placeholder={t('comment')}
            rows={3}
            onChange={onChangeComment}
            value={commentVal}
            maxLength={500}
          />
        </div>
      )}

      {currentDates}
      <div className={css['Calendar-modal__row__btn-box-conf']}>
        <Button onClick={onCancel}>{t('cancel')}</Button>
        <Button disabled={isLoadingPlan || isLoading} type='primary' onClick={() => handleOkClick()}>
          {okText}
        </Button>
      </div>
    </div>
  );
};

ConfirmModal.propTypes = {
  comment: PropTypes.string,
  dateEvent: PropTypes.string,
  disabledSelect: PropTypes.bool,
  domainCompany: PropTypes.any,
  eventTypeId: PropTypes.number,
  headerFixToModal: PropTypes.bool,
  isLoadingPlan: PropTypes.bool,
  noComment: PropTypes.bool,
  okText: PropTypes.string,
  onCancel: PropTypes.any,
  onOk: PropTypes.any,
  planningTopicId: PropTypes.number,
  rest: PropTypes.any,
  title: PropTypes.string,
  topicInfo: PropTypes.any,
  t: PropTypes.any,
  dates: PropTypes.any,
};

export default ConfirmModal;
